<template>
  <modal
    :show="isVisible"
    :title="t('Detalhes da transação')"
    elem-id="modal_credit_transaction"
    size="compactDesktop"
    :close-label="t('Fechar')"
    @close="closeModal"
    @dismiss="closeModal"
  >
    <template v-if="isVisible">
      <div data-testid="credit-transaction-modal">
        <compact-data-table :value="detailRows" />
      </div>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../../eventBus';
import { log } from '../../../utils/DebugLogger';
import { useDateFormatter } from '../../../composables/useDateFormatter';
import { formatCredits } from '../../assistant/formatCredits';
import type { AiCredits_LedgerRow } from '../../../contracts/AiCredits_LedgerRow';
import CompactDataTable from '../../../grid/CompactDataTable.vue';

const { t } = useI18n();
const { fromApiDateTimeFormat, formatDateTime } = useDateFormatter();

const isVisible = ref(false);
const currentRow = ref<AiCredits_LedgerRow | null>(null);

const detailRows = computed(() => {
  const row = currentRow.value;
  if (!row) return [];

  const signedDisplay = `${formatCredits(row.signed_micro)} ${t('cr')}`;
  const balanceDisplay = `${formatCredits(row.balance_after_micro)} ${t('cr')}`;
  const createdAt = row.created_at
    ? formatDateTime(fromApiDateTimeFormat(row.created_at))
    : '—';

  return [
    { prop: t('ID'), value: row.id },
    { prop: t('Franquia'), value: row.franchise_name ?? row.franquia_id },
    { prop: t('Tipo'), value: row.entry_type },
    { prop: t('Créditos'), value: signedDisplay },
    { prop: t('Saldo após'), value: balanceDisplay },
    { prop: t('Request ID'), value: row.request_id },
    { prop: t('Data'), value: createdAt },
  ];
});

function onOpen(payload: AiCredits_LedgerRow): void {
  log('CreditTransactionModal', 'onOpen', 'Abrindo detalhe de transação', payload);
  currentRow.value = payload ?? null;
  isVisible.value = true;
}

function closeModal(): void {
  log('CreditTransactionModal', 'closeModal', 'Fechando detalhe de transação');
  isVisible.value = false;
  currentRow.value = null;
  eventBus.emit('modal.credit-transaction.close');
}

onMounted(() => {
  eventBus.on('modal.credit-transaction.open', onOpen as (data?: unknown) => void);
});

onBeforeUnmount(() => {
  eventBus.off('modal.credit-transaction.open', onOpen as (data?: unknown) => void);
});
</script>
